import { Injectable } from '@angular/core';
import { TranslateParser } from '@ngx-translate/core';

@Injectable()
export class TranslatePoParser extends TranslateParser {
  templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

  interpolate(expr: string | Function, params?: any): string {
    let result: string;

    if (typeof expr === 'string') {
      result = this.interpolateString(expr, params);
    } else if (typeof expr === 'function') {
      result = this.interpolateFunction(expr, params);
    } else {
      // this should not happen, but an unrelated TranslateService test depends on it
      result = expr as string;
    }

    return result;
  }

  private interpolateFunction(fn: Function, params?: any) {
    return fn(params);
  }

  private interpolateString(expr: string, params?: any) {
    if (!params) {
      return expr;
    }

    return expr.replace(this.templateMatcher, (substring: string, b: string) => {
      let r = params ? params[b] : undefined;
      return this.isDefined(r) ? r : substring;
    });
  }

  private isDefined(value: any): boolean {
    return typeof value !== 'undefined' && value !== null;
  }
}